import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export const Messages: React.FC = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
      <Paper sx={{ p: 3, width: "100%", maxWidth: 480 }}>
        <Typography variant="h5" gutterBottom>
          Messages
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Messages will appear here.
        </Typography>
      </Paper>
    </Box>
  );
};
